import { store } from '../redux/store';

const useAuth = () => {
  const { token, user } = store.getState().authSlice;

  return {
    token,
    user,
  };
};

export default useAuth;
